import styled from "styled-components";
import { motion } from "framer-motion";

export const LiftRoot = styled(motion.div)`
    display: flex;
    position: relative;
    z-index: 0;

    &:hover,
    &:focus-within {
        z-index: 1;
    }
`

export const Shadow = styled(motion.div)`
    background: #000000;
    border-radius: 50%;
    filter: blur(7px);
    height: 12px;
    left: 10%;
    pointer-events: none;
    position: absolute;
    right: 10%;
    top: 68%;
    z-index: 0;
`

export const LiftContent = styled.div`
    position: relative;
    z-index: 1;
`
